import React from "react";

const SvgSearch = () => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5 22.5L17.7787 17.7787M20.25 11.8125C20.25 7.1526 16.4724 3.375 11.8125 3.375C7.1526 3.375 3.375 7.1526 3.375 11.8125C3.375 16.4724 7.1526 20.25 11.8125 20.25C16.4724 20.25 20.25 16.4724 20.25 11.8125Z"
      stroke="white"
      strokeOpacity="0.6"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgSearch;
